import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SegmentPool_instanceistwsh6nfjqm as SegmentPool_instance } from './SegmentPool.mjs';
import { arrayCopytctsywo3h7gj as arrayCopy } from '../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.u3v_1 = 8192;
        this.v3v_1 = 1024;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.x3v_1 = 0;
  _this__u8e3s4.y3v_1 = 0;
  _this__u8e3s4.z3v_1 = false;
  _this__u8e3s4.a3w_1 = false;
  _this__u8e3s4.b3w_1 = null;
  _this__u8e3s4.c3w_1 = null;
}
var SegmentClass;
function Segment() {
  if (SegmentClass === VOID) {
    class $ {
      static d3w() {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.w3v_1 = new Int8Array(8192);
        $this.a3w_1 = true;
        $this.z3v_1 = false;
        return $this;
      }
      static e3w(data, pos, limit, shared, owner) {
        var $this = createThis(this);
        init_okio_Segment($this);
        $this.w3v_1 = data;
        $this.x3v_1 = pos;
        $this.y3v_1 = limit;
        $this.z3v_1 = shared;
        $this.a3w_1 = owner;
        return $this;
      }
      f3w() {
        this.z3v_1 = true;
        return Segment().e3w(this.w3v_1, this.x3v_1, this.y3v_1, true, false);
      }
      g3w() {
        var result = !(this.b3w_1 === this) ? this.b3w_1 : null;
        ensureNotNull(this.c3w_1).b3w_1 = this.b3w_1;
        ensureNotNull(this.b3w_1).c3w_1 = this.c3w_1;
        this.b3w_1 = null;
        this.c3w_1 = null;
        return result;
      }
      h3w(segment) {
        segment.c3w_1 = this;
        segment.b3w_1 = this.b3w_1;
        ensureNotNull(this.b3w_1).c3w_1 = segment;
        this.b3w_1 = segment;
        return segment;
      }
      i3w(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount > 0 && byteCount <= (this.y3v_1 - this.x3v_1 | 0))) {
          var message = 'byteCount out of range';
          throw IllegalArgumentException().o2(toString(message));
        }
        var prefix;
        if (byteCount >= 1024) {
          prefix = this.f3w();
        } else {
          prefix = SegmentPool_instance.l3w();
          var tmp0 = this.w3v_1;
          var tmp2 = prefix.w3v_1;
          var tmp5 = this.x3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = this.x3v_1 + byteCount | 0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
        }
        prefix.y3v_1 = prefix.x3v_1 + byteCount | 0;
        this.x3v_1 = this.x3v_1 + byteCount | 0;
        ensureNotNull(this.c3w_1).h3w(prefix);
        return prefix;
      }
      m3w() {
        // Inline function 'kotlin.check' call
        if (!!(this.c3w_1 === this)) {
          var message = 'cannot compact';
          throw IllegalStateException().o(toString(message));
        }
        if (!ensureNotNull(this.c3w_1).a3w_1)
          return Unit_instance;
        var byteCount = this.y3v_1 - this.x3v_1 | 0;
        var availableByteCount = (8192 - ensureNotNull(this.c3w_1).y3v_1 | 0) + (ensureNotNull(this.c3w_1).z3v_1 ? 0 : ensureNotNull(this.c3w_1).x3v_1) | 0;
        if (byteCount > availableByteCount)
          return Unit_instance;
        this.n3w(ensureNotNull(this.c3w_1), byteCount);
        this.g3w();
        SegmentPool_instance.o3w(this);
      }
      n3w(sink, byteCount) {
        // Inline function 'kotlin.check' call
        if (!sink.a3w_1) {
          var message = 'only owner can write';
          throw IllegalStateException().o(toString(message));
        }
        if ((sink.y3v_1 + byteCount | 0) > 8192) {
          if (sink.z3v_1)
            throw IllegalArgumentException().ud();
          if (((sink.y3v_1 + byteCount | 0) - sink.x3v_1 | 0) > 8192)
            throw IllegalArgumentException().ud();
          var tmp0 = sink.w3v_1;
          var tmp2 = sink.w3v_1;
          var tmp5 = sink.x3v_1;
          // Inline function 'kotlin.collections.copyInto' call
          var endIndex = sink.y3v_1;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp = tmp0;
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          arrayCopy(tmp, tmp2, 0, tmp5, endIndex);
          sink.y3v_1 = sink.y3v_1 - sink.x3v_1 | 0;
          sink.x3v_1 = 0;
        }
        var tmp0_0 = this.w3v_1;
        var tmp2_0 = sink.w3v_1;
        var tmp4 = sink.y3v_1;
        var tmp6 = this.x3v_1;
        // Inline function 'kotlin.collections.copyInto' call
        var endIndex_0 = this.x3v_1 + byteCount | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = tmp0_0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_0, tmp2_0, tmp4, tmp6, endIndex_0);
        sink.y3v_1 = sink.y3v_1 + byteCount | 0;
        this.x3v_1 = this.x3v_1 + byteCount | 0;
      }
    }
    initMetadataForClass($, 'Segment', $.d3w);
    SegmentClass = $;
  }
  return SegmentClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Segment as Segmentnhwb43ukbiy3,
};
//endregion

//# sourceMappingURL=Segment.mjs.map
